<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>棋子配置</span>

        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="名称">
              <el-input v-model.number="item.name" style="width: 100px;" placeholder="名称" />
            </el-form-item>
            <el-form-item label="资源ID">
              <el-input v-model.number="item.resource_id" style="width: 100px;" placeholder="资源ID" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:chessIdConfig:del']" type="danger" @click="del(item.id)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:chessIdConfig:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:chessIdConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delChessIdCfg, getChessIdCfgList, updateChessIdCfg } from '@/api/config/chess-id-config'
export default {
  name: 'ChessIdConfig',
  data() {
    return {
      loading: false,
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'id': 0,
          'name': 0,
          'resource_id': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (!val.name) {
          this.msgError('名称不能为空')
          return
        }

        if (!val.resource_id) {
          this.msgError('资源ID不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      updateChessIdCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getChessIdCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'name': 0,
        'resource_id': 0
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delChessIdCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
